var map = {
	"./Accounting.jpg": "a521",
	"./Biology.jpg": "f108",
	"./Business Mathematics.jpg": "192d",
	"./Chemistry.jpg": "6c2a",
	"./Commerce English Medium.jpg": "64bf",
	"./Commerce Urdu Medium.jpg": "9355",
	"./Computer Science.jpg": "58a7",
	"./Economics English Medium.jpg": "0119",
	"./Economics Urdu Medium.jpg": "3f14",
	"./English.jpg": "aa94",
	"./Mathematics.jpg": "5066",
	"./Physics.jpg": "7360",
	"./Statistics.jpg": "fe40",
	"./Urdu.jpg": "56a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "162b";